import React from 'react';
import { Container, Button, Card } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

const glow = keyframes`
  0% { box-shadow: 0 0 10px #FF7C24; }
  50% { box-shadow: 0 0 20px #FF7C24; }
  100% { box-shadow: 0 0 10px #FF7C24; }
`;

const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const QuoteCard = styled(Card)`
  background-color: #FFFFFF;
  color: #FFFFFF;
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 600px;
  font-size: 18px;
  font-weight: 600;
  animation: ${glow} 2s ease-in-out infinite;
`;

const CorrectAnswers = styled.div`
  margin-top: 10px;
  background-color: #1E1E1E;
  border-radius: 10px;
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Highlight = styled.span`
  color: #FF7C24;
  font-size: 20px;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 100%;
  max-width: 300px;
  margin-top: 25px;
  &:hover {
    background-color: #e66a1a;
    border-color: #e66a1a;
  }
`;

const PostActivationQuotePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const numberOfOnboardingActivationCorrectAnswers =
    location.state?.numberOfOnboardingActivationCorrectAnswers || 0;

    const handleContinue = () => {
      navigate('/post-activation-coins-earned', {
        state: { numberOfOnboardingActivationCorrectAnswers },
      });
    };
    

  return (
    <StyledContainer>
      <QuoteCard>
        <p style={{ fontSize: '20px', marginBottom: '15px' }}>
          “The more you learn, the more you earn.” <br />– <em>Warren Buffett</em>
        </p>
        <CorrectAnswers>
          <FaCheckCircle color="#2ECC71" />
          You got <Highlight>{numberOfOnboardingActivationCorrectAnswers}</Highlight> question{numberOfOnboardingActivationCorrectAnswers !== 1 ? 's' : ''} correct!
        </CorrectAnswers>
      </QuoteCard>

      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationQuotePage;





// import React from 'react';
// import { Container, Button, Card } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';

// import { useLocation } from "react-router-dom";

// const location = useLocation();
// const numberOfOnboardingActivationCorrectAnswers = location.state?.numberOfOnboardingActivationCorrectAnswers || 0;

// console.log("✅ Correct Answers in Onboarding:", numberOfOnboardingActivationCorrectAnswers);


// // ✅ Styled Components for UI
// const StyledContainer = styled(Container)`
//   background-color: #232830;
//   color: #FFFFFF;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   text-align: center;
//   padding: 20px;
// `;

// const QuoteCard = styled(Card)`
//   background-color: #1E1E1E;
//   color: #FFFFFF;
//   border-radius: 15px;
//   padding: 20px;
//   margin-bottom: 20px;
//   width: 100%;
//   max-width: 500px;
//   font-size: 18px;
//   font-weight: bold;
//   text-align: center;
// `;

// const ContinueButton = styled(Button)`
//   background-color: #FF7C24;
//   border-color: #FF7C24;
//   font-size: 18px;
//   font-weight: bold;
//   border-radius: 10px;
//   padding: 12px 30px;
//   width: 100%;
//   max-width: 300px;
//   margin-top: 20px;
// `;

// const PostActivationQuotePage = () => {
//   const navigate = useNavigate();

//   const handleContinue = () => {
//     navigate('/post-activation-coins-earned');
//   };

//   return (
//     <StyledContainer>
//       {/* ✅ Motivational Quote */}
//       <QuoteCard>
//         <p>"The stock market is filled with individuals who know the price of everything, but the value of nothing." – Philip Fisher</p>
//       </QuoteCard>

//       {/* ✅ Continue Button */}
//       <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
//     </StyledContainer>
//   );
// };

// export default PostActivationQuotePage;
